<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="alertaComparte.estatus"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-text class="pt-8">
        <v-img
          v-if="getEscuela == 2" 
          src="https://lms.fastenglish.com.mx/img-front/recomendados.jpeg">
        </v-img>

        <v-img
          v-if="getEscuela == 1" 
          src="https://lms.inbi.mx/img-front/recomendados2.jpeg">
        </v-img>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          dark
          color="blue"
          @click="copiarPortapapeles( ), alertaComparte.estatus = false"
        >
          Copiar y compartir
        </v-btn>
      </v-card-actions>

      <v-speed-dial
        top
        right
        absolute
        class="mb-4 me-n4 mt-n4"
      >
        <template v-slot:activator>
          <v-btn
            icon
            fab
            small
            @click="alertaComparte.estatus = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
    </v-card>
  </v-dialog>
</template>


<script>
  const base64 = require('base-64');
  
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
	import { Clipboard } from '@capacitor/clipboard';
  import { Share } from '@capacitor/share';


	export default {
		props:[
			'alertaComparte'
	  ],

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async copiarPortapapeles( ){

        let mensaje        = ''
        let escuela          = base64.encode(this.getEscuela)
        let id_alumno        = base64.encode(this.getUsuarioLMS.id)
        let nombre_alumno    = base64.encode(this.getUsuarioLMS.nombre_completo)
        let matricula        = base64.encode(this.getUsuarioLMS.usuario)

        if( this.getEscuela == 2 ){
          mensaje = `https://fastenglish.com.mx/recomienda/#/${escuela}/${id_alumno}/${nombre_alumno}/${matricula}/`
        }else{
          mensaje = `https://inbi.mx/recomienda/#/${escuela}/${id_alumno}/${nombre_alumno}/${matricula}/`
        }

        Clipboard.write({
          string: mensaje
        });

        await Share.share({
          title: 'Comparte y gana',
          text: mensaje,
          // url: mensaje,
          dialogTitle: 'Compartir enlace',
        });

      }
    }
  }
</script>

